<template>
  <div>
    <div class="login-header">
      <div class="login-header-box">
        <div class="header-box-name">
          <img class="logo" src="@assets/img/home_logo.png" />
        </div>
        <badge :dot="!!userInfo.newCoachOrderNum && !!userInfo.newUserOrderNum">
          <!-- <div v-if="isLogin" @click="$router.push('/user')">个人中心</div> -->
          <div v-if="isLogin" @click="$router.push('/user')">个人中心</div>
          <div v-else @click="$router.push('/login')">登录</div>
        </badge>
      </div>
    </div>
    <pull-refresh
      v-model="isLoading"
      @refresh="onRefresh"
      :disabled="refreshDisable"
    >
      <div class="index" v-cloak>
        <div class="slider-banner banner">
          <swiper :options="swiperOption" v-if="banner.length > 0">
            <swiper-slide v-for="(item, index) in banner" :key="index">
              <div
                :to="item.url ? item.url : ''"
                @click="bannerLink(item)"
                class="search acea-row row-middle"
              >
                <img :src="item.pic" />
              </div>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </div>
        <!-- <div class="home-login" v-if="!isLogin">
          <div class="home-login-item" @click="$router.push('/coach_login')">
            <div class="item-box item-box-left">
              <img src="@assets/img/icon_coah.png" />
              <span>教练登录</span>
            </div>
          </div>
          <div class="home-login-item" @click="$router.push('/login')">
            <div class="item-box item-box-right">
              <img src="@assets/img/icon_user.png" />
              <span>用户登录</span>
            </div>
          </div>
        </div> -->
        <!-- <div>
          <notice-bar
            left-icon="volume-o"
            scrollable="true"
            color="red"
            mode="link"
            :text="singNew.info"
            @click="goUrl(singNew)"
          />
        </div> -->
        <Adv />
        <goods-list
          :srachState="false"
          @popChange="(e) => (refreshDisable = e)"
        ></goods-list>
      </div>
      <footer class="yh_home">
        <a class="login" @click="$router.push('/goods_list')">全部教练</a>
      </footer>
      <div class="step-img">
        <img :src="guideImg" />
      </div>
      <div class="step-img" v-if="guideOtherImg">
        <img :src="guideOtherImg" />
      </div>
      <footer
        class="yh_home"
        @click="$router.push('/settle_in')"
        v-if="$store.state.app.userCategory == 1"
      >
        <a class="login">教练入驻</a>
      </footer>
    </pull-refresh>
    <div class="kefu" @click.stop="showCode = !showCode">
      <div class="kefu-img">
        <img src="@assets/img/kefu.png" />
      </div>
    </div>
    <div class="kefu-code" v-if="showCode">
      <img :src="kefu" />
    </div>
    <!-- 续约协议弹窗 -->
    <Popup v-model="showDialog" round class="agreement-popup">
      <div class="agree-title">
        {{ articleInfo.title }}
      </div>
      <div class="agree-content">
        <div v-html="articleInfo.content"></div>
      </div>
      <div class="agree-btn" @click="dialogAction(true)">确认</div>
    </Popup>
  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "@assets/css/swiper.min.css";
import GoodsList from "../shop/GoodsList";
import {
  getHomeData,
  getShare,
  getQRcode,
  getGuide,
  getGRGuide,
  getViewDetails
} from "@api/public";
import { openShareAll } from "@libs/wechat";
import { isWeixin } from "@utils/index";
import cookie from "@utils/store/cookie";
import { mapGetters } from "vuex";
import { getUserInfo, getRecordInfo, generateTemplateLink } from "@api/user";
import { postCartAdd } from "@/api/store";
import { postOrderConfirm, createOrder, getOrderList } from "@/api/order";
import { getGameInfo } from "@/api/game";
import { pay } from "@libs/wechat";

import {
  PullRefresh,
  // NoticeBar,
  Toast,
  Badge,
  Popup
} from "vant";
import Adv from "@/components/sh-adv";
// const LONGITUDE = "user_longitude";
// const LATITUDE = "user_latitude";
const MAPKEY = "mapKey";
const BACK_URL = "login_back_url";

export default {
  name: "Index",
  components: {
    swiper,
    swiperSlide,
    GoodsList,
    PullRefresh,
    // NoticeBar,
    Adv,
    // Toast,
    Badge,
    Popup
  },
  props: {},
  data: function () {
    return {
      count: 0,
      isLoading: false,
      showCoupon: false,
      logoUrl: "",
      banner: [],
      roll: [],
      bastList: [],
      firstList: [],
      info: {
        fastList: [],
        bastBanner: [],
        bastList: [],
      },
      likeInfo: [],
      lovely: [],
      benefit: [],
      swiperOption: {
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        autoplay: {
          disableOnInteraction: false,
          delay: 2000,
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true,
      },
      swiperRoll: {
        direction: "vertical",
        autoplay: {
          disableOnInteraction: false,
          delay: 2000,
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true,
      },
      swiperScroll: {
        freeMode: true,
        freeModeMomentum: false,
        slidesPerView: "auto",
        observer: true,
        observeParents: true,
      },
      swiperBoutique: {
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        autoplay: {
          disableOnInteraction: false,
          delay: 2000,
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true,
      },
      swiperProducts: {
        freeMode: true,
        freeModeMomentum: false,
        slidesPerView: "auto",
        observer: true,
        observeParents: true,
      },
      showCode: false,
      kefu: "",
      guideImg: "",
      refreshDisable: false,
      guideOtherImg: "",
      showDialog: false,
      articleInfo: {},
      tempProductData: null,
    };
  },
  computed: {
    singNew() {
      return this.roll.length > 0 ? this.roll[0] : "你还没添加通知哦！";
    },
    ...mapGetters(["isLogin", "userInfo"]),
  },
  mounted: function () {
    console.log("Index.vue组件挂载执行");
    this.getHome();
    this.getQRcodeImg();
    this.getGuideImg();
    this.getGuideOtherImg();
    this.isLogin && this.User();
    const backUrl = cookie.get(BACK_URL);
    // console.log(BACK_URL, backUrl);
    this.recordHandle();
    this.getGameInfoRouter();

    // 如果URL中有temp参数，先获取协议再检查temp参数
    if (this.$route.query.temp) {
      console.log("检测到temp参数，先获取协议");
      this.getAgree().then(() => {
        console.log("协议获取完成，开始处理temp参数");
        this.checkTempParam();
      });
    } else {
      console.log("没有temp参数，正常获取协议");
      this.getAgree();
    }
  },
  activated() {
    this.isLogin && this.User();
    const backUrl = cookie.get("login_back_url");
    // console.log("backUrl", backUrl);
  },
  methods: {
    recordHandle(userInfo) {
      // 查询是否有recordId这个参数
      let recordId = this.$route.query.recordId;
      if (recordId) {
        getRecordInfo(recordId).then((res) => {
          this.$router.push({
            path: "/detail/" + res.data.productId,
            query: {
              recordId
            }
          })

          //   // console.log("this.$store", userInfo);
          //   if (res.success && this.isLogin) {
          //     // console.log(res.data.phone, userInfo.phone);
          //     if (res.data.phone == userInfo.phone) {
          //       // console.log("跳转到教练");
          //       // cookie.remove("recordId");
          //       // 跳转到教练页，参数为productId
          //       this.$router.push({
          //         path: "/detail/" + res.data.productId,
          //         query: {
          //           pageType: "coach",
          //         },
          //       });
          //     }
          //   } else {
          //     // cookie.set("recordId", recordId);

          //     this.$router.push({
          //       path:  "/detail/" + res.data.productId,
          //       query: {
          //         recordId
          //       }
          //     });
          //   }
        });
      }
    },
    // 获取游戏信息
    getGameInfoRouter() {
      // console.log("开始获取游戏信息");
      const { code, pwd } = this.$route.query;
      const url = window.location.href;
      // console.log("this.isLogin", this.isLogin)

      // let url = "https://m.lcwlit.com/?code=gcfPFia0";
      if (code) {
        if (!this.isLogin) {
          cookie.set(BACK_URL, this.$route.fullPath);
          this.$router.push({
            path: "/login",
            query: {
              redirect: this.$route.fullPath,
            }
          });
          return;
        }
        getGameInfo({ gameUrl: url })
            .then((res) => {
              if (res.success) {
                // console.log("res", res);
                // 0 未开始
                // 1 进行中
                // 2 已结束
                if (res.data.gameStatus === 0) {
                  this.$router.push({
                    path: "/game/choose",
                    query: {
                      gameId: res.data.gameId,
                      step: res.data.isCreate == 1 ? 3 : undefined,
                      // pwd,
                    },
                  });
                } else if (res.data.gameStatus === 1) {
                  if (res.data.isCreate === 0) {
                    this.$router.push({
                      path: "/game/choose",
                      query: {
                        gameId: res.data.gameId,
                        step: res.data.isCreate == 1 ? 3 : undefined,
                        gameStart: 1,
                        // pwd,
                      },
                    });
                  } else {
                    this.$router.push({
                      path: "/game/start",
                      query: {
                        gameId: res.data.gameId,
                      },
                    });
                  }
                } else {
                  this.$dialog.message("游戏已结束");
                }
              }
            })
            .catch((err) => {
              this.$dialog.message(err.msg);
            });
      }
    },
    // 获取各种协议
    getAgree: function () {
      console.log("getAgree函数被调用");
      return getViewDetails(51)
        .then((res) => {
          console.log("getViewDetails接口响应:", res);
          this.articleInfo = res.data;
          console.log("协议内容:", this.articleInfo);

          // 如果是从推广链接进来的，设置showDialog为true
          if (this.$route.query.temp && this.tempProductData) {
            console.log("从推广链接进入，准备显示协议");
            this.$nextTick(() => {
              this.showDialog = true;
              console.log("协议弹窗已设置为显示");
            });
          }
          return res;
        })
        .catch(err => {
          console.error("getViewDetails接口错误:", err);
          return Promise.reject(err);
        });
    },
    User: function () {
      let that = this;
      getUserInfo().then((res) => {
        this.$store.commit("SET_USER", res.data);
        this.recordHandle(res.data);
      });
    },
    goUrl(e) {
      if (e && e.url) return this.$router.push({ path: e.url });
    },
    onRefresh() {
      this.getHome();
      setTimeout(() => {
        Toast("刷新成功");
        this.isLoading = false;
        this.count++;
      }, 500);
    },
    getHome() {
      let that = this;
      getHomeData().then((res) => {
        that.mapKey = res.data.mapKey;
        cookie.set(MAPKEY, that.mapKey);
        that.logoUrl = res.data.logoUrl;
        that.$set(that, "banner", res.data.banner);
        that.setOpenShare();
      });
    },
    getQRcodeImg: function () {
      getQRcode().then((res) => {
        this.kefu = res.data.value;
      });
    },
    getGuideImg: function () {
      getGuide().then((res) => {
        this.guideImg = res.data.value;
      });
    },

    getGuideOtherImg: function () {
      getGRGuide().then((res) => {
        res.data && res.data.value && (this.guideOtherImg = res.data.value);
      });
    },
    setOpenShare: function () {
      if (isWeixin()) {
        getShare().then((res) => {
          var data = res.data.data;
          var configAppMessage = {
            desc: data.synopsis,
            title: data.title,
            link: location.href,
            imgUrl:
              "https://coach.pgyfamilycoach.com/images/static/file/pic/20231117181009931063.png",
          };
          // console.log("configAppMessage", configAppMessage);
          openShareAll(configAppMessage);
        });
      }
    },
    bannerLink(item) {
      if (item.url) {
        this.$router.push(item.url);
        return;
      }
      if (item.uniapp_url) {
        location.href = item.uniapp_url;
        return;
      }
    },
    // 确认弹窗按钮点击处理
    dialogAction(e) {
      console.log("dialogAction被调用，值为:", e);
      this.showDialog = false;
      console.log("对话框关闭，showDialog设置为false");

      if (e) {
        console.log("确认按钮被点击");

        // 如果有订单ID，跳转到订单详情页面
        if (this.tempProductData && this.tempProductData.orderId) {
          console.log("跳转到订单详情页面");
          this.$router.push({
            path: '/order/detail/' + this.tempProductData.orderId,
            query: {
              from: 'order'
            }
          });
        } else {
          console.log("调用processOrder()");
          this.processOrder();
        }
      } else {
        console.log("对话框被取消");
      }
    },

    checkTempParam() {// 检查URL中是否有temp参数
      console.log("checkTempParam方法被调用");
      const { temp } = this.$route.query;
      console.log("temp参数:", temp);

      // 如果有temp参数，显示协议弹窗
      if (temp) {
        console.log("找到temp参数，检查登录状态");
        // 如果用户未登录，先跳转到登录页面
        if (!this.isLogin) {
          console.log("用户未登录，重定向到登录页面");
          cookie.set(BACK_URL, this.$route.fullPath);
          this.$router.push({
            path: "/login",
            query: {
              redirect: this.$route.fullPath,
            }
          });
          return;
        }

        // 用户已登录后，开始生成模板链接
        const templateData = {
          createTime: "",
          id: 0,
          name: "",
          price: 0,
          onePrice:0,
          sku:0,
          productId: 0,
          shareLink: window.location.href,
          unique: "",
          updateTime: "" ,
          isDel:0,
          orderId:null
        };

        console.log("调用generateTemplateLink接口");
        // 获取模板数据
        generateTemplateLink(templateData)
          .then(res => {
            console.log('根据Link获取数据:', res);

            if (!res.data) {
              console.log("接口未返回数据");
              Toast.fail('该套餐已下架请联系教练');
              return Promise.reject('该套餐已下架请联系教练');
            }

            // 保存返回的模板数据
            const templateData = res.data;
            console.log('模板数据:', templateData);

            // 保存套餐数据到tempProductData，供后续弹窗使用
            this.tempProductData = {
              ...templateData
            };
            console.log('保存的套餐数据:', this.tempProductData);

            if (!templateData.productId) {
              console.log("模板数据中没有productId");
              Toast.fail('链接无效或已过期');
              return Promise.reject('无效的商品ID');
            }

            // 跳转到问卷页面，传递所有必要的参数，包括套餐名称
            console.log("跳转到填写续约资料页面");
            this.$router.push({
              path: '/order/questionnaire/' + templateData.productId,
              query: {
                type: 1, // 续约类型
                temp: temp, // 传递temp参数
                fromIndex: 'true', // 标记来自首页
                orderId: templateData.orderId || null, // 传递订单ID
                uniqueId: templateData.unique || '', // 传递unique
                productId: templateData.productId, // 传递产品ID
                price: templateData.price || 0, // 传递价格
                onePrice: templateData.onePrice || 0, // 传递单价
                sku: templateData.sku || 0, // 传递SKU
                name: templateData.name || '' // 传递套餐名称
              }
            });
          })
          .catch(err => {
            Toast.clear();
            console.error('获取数据失败:', err);
            Toast.fail(typeof err === 'string' ? err : '获取数据失败，请稍后重试');
          });
      } else {
        console.log("未找到temp参数");
      }
    },

    // 处理订单
    processOrder() {
      if (!this.tempProductData || !this.tempProductData.productId) {
        Toast.fail('获取产品信息失败');
        return;
      }

      // 显示加载提示
      Toast.loading({
        message: '正在处理订单...',
        forbidClick: true,
        duration: 0
      });

      // 用于存储中间数据
      let productData = this.tempProductData;
      let cartId = null;
      let orderConfirmData = null;

      // 3. 第二步：构建添加商品订单请求参数
      const orderData = {
        cartNum: 1,
        new: 1,
        productId: productData.productId,
        uniqueId: productData.unique
      };

      console.log('添加购物车参数:', orderData);

      // 添加到购物车
      postCartAdd(orderData)
        .then(cartRes => {
          console.log('添加购物车结果:', cartRes);

          if (!cartRes || !cartRes.data || !cartRes.data.cartId) {
            Toast.clear();
            Toast.fail('创建购物车失败');
            return Promise.reject('无法获取购物车ID');
          }

          // 保存购物车ID
          cartId = cartRes.data.cartId;
          console.log('获取到购物车ID:', cartId);

          // 4. 第三步：订单确认
          return postOrderConfirm(cartId, 0);
        })
        .then(orderRes => {
          console.log('订单确认结果:', orderRes);

          if (!orderRes || !orderRes.data || !orderRes.data.orderKey) {
            Toast.clear();
            Toast.fail('订单确认失败');
            return Promise.reject('订单确认失败');
          }

          // 保存订单确认数据
          orderConfirmData = orderRes.data;
          console.log('订单确认数据:', orderConfirmData);

          // 5. 第四步：构建创建订单的参数
          const createOrderData = {
            addressId: null,
            channelid: null,
            couponId: 0,
            firstOrder: this.userInfo.ProductIds && this.userInfo.ProductIds.includes(productData.productId) ? 0 : 1,
            from: "weixin",
            mark: "",
            payType: "weixin",
            phone: "",
            pinkId: 0,
            realName: "",
            shippingType: 1,
            source: "2",
            useIntegral: 0,
            welfareOrder: 0
          };

          console.log('创建订单参数:', orderConfirmData.orderKey, createOrderData);

          // 创建订单后端返回商品编号id
          return createOrder(orderConfirmData.orderKey, createOrderData);
        })
        .then(finalOrderRes => {
          Toast.clear();
          console.log('订单创建结果:', finalOrderRes);

          if (!finalOrderRes) {
            console.warn('创建订单响应为空，尝试获取最近订单');
            this.getRecentOrderAsFallback(orderConfirmData.priceGroup.totalPrice);
            return;
          }

          // 处理不同的支付状态
          const data = finalOrderRes.data;
          if (!data || !data.status) {
            Toast.fail("创建订单失败，请稍后重试");
            return;
          }

          let orderId = null;

          switch (data.status) {
            case "ORDER_EXIST":
            case "EXTEND_ORDER":
            case "PAY_DEFICIENCY":
            case "PAY_ERROR":
              Toast.fail(finalOrderRes.msg);
              // 跳转到订单状态页面
              if (data.result && data.result.orderId) {
                orderId = data.result.orderId;
                this.$router.replace({
                  path: "/order/status/" + orderId,
                  query: { type: 0 },
                });
              }
              break;

            case "SUCCESS":
              Toast.success(finalOrderRes.msg);
              // 跳转到订单状态页面
              if (data.result && data.result.orderId) {
                orderId = data.result.orderId;
                this.$router.replace({
                  path: "/order/status/" + orderId,
                  query: {
                    price: orderConfirmData.priceGroup.totalPrice,
                    type: 0,
                  },
                });
              }
              break;

            case "WECHAT_H5_PAY":
              // H5支付，直接跳转到微信支付页面
              if (data.result && data.result.orderId) {
                orderId = data.result.orderId;
                // 先记录订单ID，然后跳转到微信H5支付
                this.$router.replace({
                  path: "/order/status/" + orderId,
                  query: {
                    price: orderConfirmData.priceGroup.totalPrice,
                    type: 0,
                  },
                });
                setTimeout(() => {
                  location.href = data.result.jsConfig.mweb_url;
                }, 100);
              }
              break;

            case "WECHAT_PAY":
              // 微信JSAPI支付，直接拉起支付
              if (data.result && data.result.jsConfig) {
                if (data.result.orderId) {
                  orderId = data.result.orderId;
                }
                // 使用pay方法拉起微信支付
                pay(data.result.jsConfig).finally(() => {
                  // 支付完成后跳转到订单状态页
                  if (orderId) {
                    this.$router.replace({
                      path: "/order/status/" + orderId,
                      query: {
                        price: orderConfirmData.priceGroup.totalPrice,
                        type: 0,
                      },
                    });
                  }
                });
              } else {
                Toast.fail("支付参数错误，请稍后重试");
              }
              break;

            default:
              Toast.fail("未知状态，请前往订单列表查看");
              // 尝试获取最近订单作为备选方案
              this.getRecentOrderAsFallback(orderConfirmData.priceGroup.totalPrice);
          }
        })
        .catch(err => {
          Toast.clear();
          console.error('订单创建流程失败:', err);
          Toast.fail(typeof err === 'string' ? err : '创建订单失败，请稍后重试');

          // 出错时也尝试获取最近订单
          if (orderConfirmData && orderConfirmData.priceGroup && orderConfirmData.priceGroup.totalPrice) {
            console.warn('尝试获取最近订单作为备选方案');
            this.getRecentOrderAsFallback(orderConfirmData.priceGroup.totalPrice);
          }
        });
    },

    // 备用方案：获取最近订单
    getRecentOrderAsFallback(price) {
      Toast.loading({
        message: '正在获取订单信息...',
        forbidClick: true,
        duration: 0
      });

      // 调用订单列表API获取最近订单
      getOrderList({ page: 1, limit: 20, type: 10, userCategory: 1 })
        .then(res => {
          Toast.clear();
          console.log('获取最近订单列表:', res);

          if (res.success && res.data && res.data.length > 0) {
            // 获取第一条订单(最新订单)的ID
            const orderId = res.data[0].orderId;
            console.log('找到最近订单ID:', orderId);

            if (orderId) {
             // Toast.success('找到最近创建的订单，即将跳转到支付页面');

              // 延迟跳转到订单详情页面
              setTimeout(() => {
                this.$router.push({

                  path: '/order/detail/' + orderId,
                  query: {
                    from: 'order'
                  }
                });
              }, 1000);
              return;
            }
          }

          Toast.fail('无法获取订单信息，请前往订单列表查看');
          // 最后的备选方案：跳转到订单列表
          setTimeout(() => {
            this.$router.push({
              path: '/order/list',
              query: { type: 0 } // 待付款订单
            });
          }, 2000);
        })
        .catch(err => {
          Toast.clear();
          console.error('获取订单列表失败:', err);
          Toast.fail('无法获取订单信息，请前往订单列表查看');

          // 最后的备选方案：跳转到订单列表
          setTimeout(() => {
            this.$router.push({
              path: '/order/list',
              query: { type: 0 } // 待付款订单
            });
          }, 2000);
        });
    },

  },
  created() {
    console.log("Index.vue创建钩子执行");
    // 在mounted中处理checkTempParam以确保顺序正确
    // 不在created中调用checkTempParam
  },
  watch: {
    $route: {
      handler(to, from) {
        console.log('路由变化：', from.path, '->', to.path);

        // 如果是从问卷页面返回，且有temp参数
        if (from.path && from.path.includes('/order/questionnaire')
            && to.query.temp && to.query.fromQuestionnaire === 'true') {
          console.log('从问卷页面返回到首页，且带有temp参数');

          // 如果有套餐数据，直接显示协议弹窗
          if (this.tempProductData && this.tempProductData.productId) {
            console.log('检测到套餐数据，显示协议弹窗');
            this.$nextTick(() => {
              this.showDialog = true;
            });
          } else {
            // 重新获取数据
            console.log('未检测到套餐数据，重新处理temp参数');
            this.checkTempParam();
          }
        }
      },
      immediate: false
    }
  },
};
</script>
<style scoped>
.login-header {
  height: 0.84rem;
  width: 100%;
  background: #0ce6df;
  position: sticky;
  top: 0;
  z-index: 999;
}

.login-header-box {
  height: 100%;
  width: 100%;
  padding: 0 0.3rem;
  box-sizing: border-box;
  position: relative;
  display: flex;
  color: #ffffff;
  align-items: center;
}

.header-box-name {
  flex: 1;
}

.header-box-name .logo {
  vertical-align: middle;
  height: 0.4rem;
}

.home-login {
  overflow: hidden;
}

.home-login .home-login-item {
  width: 50%;
  float: left;
  padding: 0.28rem;
}

.home-login .item-box {
  padding: 0.19rem 0.23rem;
  color: #ffffff;
  font-size: 0.38rem;
  border-radius: 0.1rem;
}

.home-login .item-box img {
  vertical-align: middle;
  margin-right: 0.19rem;
  height: 0.6rem;
}

.home-login .item-box-left {
  background-color: #f7c646;
}

.home-login .item-box-right {
  background-color: #b3bff3;
}

.index {
  background-color: #fff;
}

.yh_home {
  width: 100%;
  background-color: #f5f5f5;
  padding: 0.4rem 0.3rem;
  box-sizing: border-box;
  overflow: hidden;
}

.yh_home > a {
  display: block;
  color: #fff;
  width: 100%;
  height: 0.68rem;
  border-radius: 0.68rem;
  background: #0ce6df;
  line-height: 0.68rem;
  text-align: center;
}

.step-img {
  width: 100%;
}

.step-img img {
  width: 100%;
  height: auto;
  display: block;
}

.kefu {
  position: fixed;
  bottom: 1.5rem;
  right: 0.1rem;
  text-align: center;
}

.kefu .kefu-img {
  width: 1rem;
}

.kefu img {
  width: 100%;
}

.kefu-code {
  position: fixed;
  bottom: 0.77rem;
  right: 1.3rem;
}

.kefu-code img {
  width: 2.2rem;
  height: 2.2rem;
}

.agreement-popup {
  width: 90%;
  max-width: 650px;
  border-radius: 10px;
}

.agree-title {
  font-size: 0.4rem;
  text-align: center;
  padding: 0.3rem;
  font-weight: bold;
  border-bottom: 1px solid #eee;
}

.agree-content {
  height: 60vh;
  overflow-y: auto;
  padding: 0.3rem;
  font-size: 0.28rem;
  line-height: 1.6;
}

.agree-btn {
  border-top: 1px solid #eee;
  padding: 0.3rem 0;
  text-align: center;
  color: #0ce6df;
  font-size: 0.32rem;
  font-weight: bold;
}
</style>
